module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutLoginLineHook":{"loginLine":"Máte u nás účet? {link} a už nebudete muset znovu vyplňovat své kontaktní údaje.","loginText":"Přihlaste se"}},"en":{}}')
  delete Component.options._Ctor
}
